<span class="switch" [class.checked]="active" [class.disabled]="disabled" (click)="toggle()">
  <small></small>
  <input type="checkbox" name="active" [(ngModel)]="active" style="display: none" /><span class="switch-text"></span>
</span>
